import { Directive, Input } from '@angular/core';
import { ViewDirective } from './view.directive';
import { GA4 } from '../models/ga4.model';

@Directive({
    selector: '[ga4ViewItemList]'
})
export class ViewItemListDirective extends ViewDirective<GA4.ViewItemList> {
    track: GA4.ViewItemList = <GA4.ViewItemList>{ __event_name: 'view_item_list' };
    @Input()
    set items(data: Array<Omit<GA4.Item, '__event_name'>>) {
        this.track.items = data;
    }
    @Input()
    set item_list_name(data: string) {
        this.track.item_list_name = data;
    }
    @Input()
    set item_list_id(data: string) {
        this.track.item_list_id = data;
    }
}
